export default "__VITE_ASSET__Bol7_5C8__"